import { render, staticRenderFns } from "./product-itinerary-plus.vue?vue&type=template&id=01ba5f18&scoped=true&"
import script from "./product-itinerary-plus.vue?vue&type=script&lang=js&"
export * from "./product-itinerary-plus.vue?vue&type=script&lang=js&"
import style0 from "./product-itinerary-plus.vue?vue&type=style&index=0&id=01ba5f18&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ba5f18",
  null
  
)

export default component.exports